export const MOBILE = (typeof window !== 'undefined') ? (window.screen.availWidth < 800) : true;
export const API_BASE_URL = 'http:// ${HOST}:${PORT}';
export const USE_MOCK_SERVICE: any = { CAN_MOCK: false };
export const DEFAULT_NO_OPTION_IMAGE: string = 'assets/images/dealer-option-no-image.jpg';
export const TOTAL_OPTIONAL_EQUIPMENT: string = 'Total Optional Equipment';

// View Constants
export class ViewConstants {
  // Constant to TITlE
  static TITLE = 'TITLE';

  // constant for routerTransition
  static ROUTER_TRANSITION = 'routerTransition';
  // constant for void
  static VOID = 'void';
  // constant for fixed
  static FIXED = 'fixed';
  // constant for 100%
  static HUNDRED_PERCENTAGE = '100%';
  // constant for *
  static STAR = '*';
  // constant for :enter
  static COLON_ENTER = ':enter';
  // constant for translateX(-100%)
  static TRANSLATE_X_HYPHEN_HUNDRED_PERCENTAGE = 'translateX(-100%)';
  // constant for translateX(100%)
  static TRANSLATE_X_HUNDRED_PERCENTAGE = 'translateX(100%)';
  // constant for translateY(-100%)
  static TRANSLATE_Y_HYPHEN_HUNDRED_PERCENTAGE = 'translateY(-100%)';
  // constant for translateY(-100%)
  static TRANSLATE_Y_HUNDRED_PERCENTAGE = 'translateY(100%)';
  // constant for 0.5s ease-in-out
  static ZERO_FIVE_S_EASE_IN_OUT = '0.5s ease-in-out';
  // constant for 0.6s ease-in-out
  static ZERO_SIX_S_EASE_IN_OUT = '0.6s ease-in-out';
  // constant for :leave
  static COLON_LEAVE = ':leave';
  // constant for translateX(0%)
  static TRANSLATE_X_ZERO_PERCENTAGE = 'translateX(0%)';
  // constant for translateY(0%)
  static TRANSLATE_Y_ZERO_PERCENTAGE = 'translateY(0%)';
}
